<template>
  <v-container style="flex: 0 0;" pa-0>
    <div class="spaced-label-2 text-xs-center pt-2 pb-1 px-3">
      Import summary
    </div>
    <v-layout class="px-5">
      <ButtonLabel :count="errorCount" :active.sync="showError" label="Error" color="error" />
      <ButtonLabel :count="warningCount" :active.sync="showWarning" label="Warning" color="warning" />
      <ButtonLabel :count="infoCount" :active.sync="showInfo" label="Info" color="info" />
    </v-layout>
  </v-container>
</template>

<script>
  import ButtonLabel from './ButtonLabel'
  export default {
    components: {
      ButtonLabel,
    },
    data: () => ({
      showError: true,
      showWarning: true,
      showInfo: false,
    }),
    computed: {
      logs() {
        return this.$store.getters['reviewingestionresults/logs']
      },
      errorCount() {
        return this.logs.filter(log => log.severity == 'error' && !log.ignore).length
      },
      warningCount() {
        return this.logs.filter(log => log.severity == 'warning' && !log.ignore).length
      },
      infoCount() {
        return this.logs.filter(log => log.severity == 'info' && !log.ignore).length
      },
      showLogs() {
        return this.$store.getters['reviewingestionresults/showLogs']
      },
    },
    watch: {
      showError() {
        this.updateValues()
      },
      showWarning() {
        this.updateValues()
      },
      showInfo() {
        this.updateValues()
      },
    },
    methods: {
      updateValues() {
        let showLogs = { error: this.showError, warning: this.showWarning, info: this.showInfo }
        this.$store.dispatch('reviewingestionresults/setShowLogs', showLogs)
      },
      initialize() {
        this.showError = this.showLogs.error
        this.showWarning = this.showLogs.warning
        this.showInfo = this.showLogs.info
      },
    },
    mounted() {
      this.initialize()
    },
  }
</script>